import React from 'react';
const NoDataBox = (props) => (
  <div className='flex-wrap w-full p-3 mx-auto md:flex '>
    <div className='w-full bg-white rounded md:box-content'>
      <div className='flex w-full p-6'>
        <div className='w-3/5 text-base font-semibold text-summary-header '>{props.text}</div>
      </div>
    </div>
  </div>
);

export default NoDataBox;
